"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var BlockTopGalleryAction;
(function (BlockTopGalleryAction) {
    BlockTopGalleryAction.BLOCK_TOP_GALLERY_SET_CURRENT_INDEX = 'BLOCK_TOP_GALLERY_SET_CURRENT_INDEX';
    BlockTopGalleryAction.setCurrentIndex = typesafe_actions_1.createAction(BlockTopGalleryAction.BLOCK_TOP_GALLERY_SET_CURRENT_INDEX, function (resolve) { return function (index, noSmooth) {
        if (noSmooth === void 0) { noSmooth = false; }
        return resolve({ index: index, noSmooth: noSmooth });
    }; });
})(BlockTopGalleryAction || (BlockTopGalleryAction = {}));
exports.default = BlockTopGalleryAction;
